import * as React from "react";
import { connect } from "react-redux";

import SidePrice from "./side-price";
import { pick, experiencesPricesPropType, IdType } from "../../model/utils";

const ExperiencePrice = ({ experiencesPrices, experienceId }) => (
  <SidePrice price={experiencesPrices[experienceId]} />
);

ExperiencePrice.propTypes = {
  experienceId: IdType.isRequired,
  experiencesPrices: experiencesPricesPropType
};

export default connect(pick(["experiencesPrices"]))(ExperiencePrice);
